import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  pin: function pin() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      position: absolute;\n    "])));
  },
  pinTop: function pinTop() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      clip-path: polygon(0 0, 50% 100%, 100% 0);\n    "])));
  },
  pinBottom: function pinBottom() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      clip-path: polygon(0 100%, 50% 0, 100% 100%);\n    "])));
  },
  pinLeft: function pinLeft() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      clip-path: polygon(0 0, 100% 50%, 0 100%);\n    "])));
  },
  pinRight: function pinRight() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      clip-path: polygon(100% 0, 0 50%, 100% 100%);\n    "])));
  }
});